import { defineComponent as _defineComponent } from 'vue'
import { computed, Ref, ref } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import {
    BorrowCalculatorInterface,
    BorrowCalculatorFields,
    CalculatorOptions,
    CalculatorOptionsFields,
    Periodicity,
    getPeriodicityKey,
  } from "@/types/BorrowCalculator";
  import {
    formatPriceToNumber,
    formatPriceTrim,
  } from "@/helpers/transformation/price";

  type propsType = {
    form: BorrowCalculatorInterface;
    formCalculatorOptions: CalculatorOptions;
  };
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorIncomeSection',
  props: {
    form: {},
    formCalculatorOptions: {}
  },
  emits: ["updateForm", "updateFormCalculatorOptions"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;
  const activeApplicant = computed(() => getActiveApplicant());

  const getActiveApplicant = () => {
    if (props.formCalculatorOptions?.isApplicant1Active) {
      return {
        netSalaryKey: BorrowCalculatorFields.NET_SALARY_1,
        netSalaryValue: props.form?.NetSalary1,
        netSalaryFreKey: BorrowCalculatorFields.NET_SALARY_FRE_1,
        netSalaryFreValue: props.form?.NetSalaryFre1,
        hasAdditionalIncomeKey: CalculatorOptionsFields.HAS_ADDITIONAL_INCOME_1,
        hasAdditionalIncomeValue:
          props.formCalculatorOptions?.hasAdditionalIncome1,
        additionalIncomeKey: CalculatorOptionsFields.ADDITIONAL_INCOME_1,
        additionalIncomeValue: props.formCalculatorOptions?.additionalIncome1,
      };
    }

    return {
      netSalaryKey: BorrowCalculatorFields.NET_SALARY_2,
      netSalaryValue: props.form?.NetSalary2,
      netSalaryFreKey: BorrowCalculatorFields.NET_SALARY_FRE_2,
      netSalaryFreValue: props.form?.NetSalaryFre2,
      hasAdditionalIncomeKey: CalculatorOptionsFields.HAS_ADDITIONAL_INCOME_2,
      hasAdditionalIncomeValue:
        props.formCalculatorOptions?.hasAdditionalIncome2,
      additionalIncomeKey: CalculatorOptionsFields.ADDITIONAL_INCOME_2,
      additionalIncomeValue: props.formCalculatorOptions?.additionalIncome2,
    };
  };

  const updateForm = (field: BorrowCalculatorFields, value: string) => {
    emits("updateForm", field.toString(), value);
  };

  const updateFormInput = (e: Event, field: BorrowCalculatorFields) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    const income = formatPriceTrim(target.value);

    emits("updateForm", field, income);
  };

  const updateHasAdditonalIncome = (
    field: CalculatorOptionsFields,
    fieldValue: CalculatorOptionsFields,
    value: boolean
  ) => {
    emits("updateFormCalculatorOptions", field.toString(), value);

    if (!value) {
      updateAdditonalIncome(new Event("event"), fieldValue, "$0");
    }
  };

  const updateAdditonalIncome = (
    e: Event,
    field: CalculatorOptionsFields,
    value?: string
  ) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    const income = !value ? formatPriceTrim(target.value) : value;

    updateFormCalculatorOptions(field, income);
    const additionalIncome1 = formatPriceToNumber(
      props.formCalculatorOptions.additionalIncome1
    );
    const additionalIncome2 = formatPriceToNumber(
      props.formCalculatorOptions.additionalIncome2
    );
    const formatedAdditonalIncome = formatPriceTrim(
      additionalIncome1 + additionalIncome2
    );

    emits(
      "updateForm",
      BorrowCalculatorFields.NET_SALARY_3,
      formatedAdditonalIncome
    );
  };

  const updateFormCalculatorOptions = (
    field: CalculatorOptionsFields,
    value: string | boolean
  ) => {
    emits("updateFormCalculatorOptions", field.toString(), value);
  };

const __returned__ = { emits, props, activeApplicant, getActiveApplicant, updateForm, updateFormInput, updateHasAdditonalIncome, updateAdditonalIncome, updateFormCalculatorOptions, computed, Ref, ref, DropDown, get BorrowCalculatorInterface() { return BorrowCalculatorInterface }, get BorrowCalculatorFields() { return BorrowCalculatorFields }, get CalculatorOptions() { return CalculatorOptions }, get CalculatorOptionsFields() { return CalculatorOptionsFields }, get Periodicity() { return Periodicity }, get getPeriodicityKey() { return getPeriodicityKey }, get formatPriceToNumber() { return formatPriceToNumber }, get formatPriceTrim() { return formatPriceTrim } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})